module.exports = __webpack_public_path__ + "img/qa-1.cd2df4e8.png";